<template>
    <div class="pt-5">
        <div class="container">
            <div class="kt-heading kt-heading--md">
                Tu KIA ha sido cotizado
                <hr/>
            </div>
        </div>
        <section class="container">
            <div class="kt-portlet">
                <div class="alert alert-primary text-center">
                    <h1 class="col">
                        Tu <b>KIA</b> ha sido personalizado, pronto recibirás la
                        cotización en tu correo electrónico <br />
                        <br />
                        Gracias por preferir <b>KIA</b>
                    </h1>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "gracias",
        mounted() {
            this.$store.commit('limpiar', null);
            this.$store.commit('setActual', null);
            this.$store.commit('setSubActual',0);
            this.$analytics.fbq.event('track','CompleteRegistration');
        }
    }
</script>

<style scoped>

</style>
